import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { getActivityDyx, updateActivityDyx, addActivity } from '@/services/marketing/activity';
import Cookie from 'js-cookie';
import { Tree } from 'ant-design-vue';
import { TreeSelect } from 'ant-design-vue';
import FooterToolBar from '@/components/tool/FooterToolBar';
import importfailed from '@/components/importfailed/index';
import selectDyx from '@/components/commonAdd/selectGroupDyx.vue';
export default {
  name: 'ActivityProduct',
  i18n: require('../i18n-activity'),
  components: {
    TreeSelect: TreeSelect,
    Tree: Tree,
    FooterToolBar: FooterToolBar,
    importfailed: importfailed,
    selectDyx: selectDyx
  },
  props: {
    basicInformation: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    activityId: {
      type: Number,
      default: null
    },
    lookinfo: {
      type: Number,
      default: null
    },
    basicProductContent: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var columns1 = [{
      dataIndex: 'erpCustomerCode',
      title: this.$t('account.dyxNumber'),
      align: 'left'
    }, {
      title: this.$t('account.dyxName'),
      dataIndex: 'goodsName',
      scopedSlots: {
        customRender: 'goodsName'
      }
    }, {
      title: this.$t('account.status'),
      dataIndex: 'status',
      scopedSlots: {
        customRender: 'status'
      }
    }, {
      title: this.$t('account.yetai'),
      dataIndex: 'busFormatName'
    }, {
      title: this.$t('account.ddz'),
      dataIndex: 'sellerName'
    }, {
      title: this.$t('emailAction'),
      dataIndex: 'action',
      scopedSlots: {
        customRender: 'action'
      }
    }];
    var columns2 = [{
      dataIndex: 'erpCustomerCode',
      title: this.$t('account.dyxNumber')
    }, {
      title: this.$t('account.dyxName'),
      dataIndex: 'goodsName',
      scopedSlots: {
        customRender: 'goodsName'
      }
    }, {
      title: this.$t('account.status'),
      dataIndex: 'status',
      scopedSlots: {
        customRender: 'status'
      }
    }, {
      title: this.$t('account.yetai'),
      dataIndex: 'busFormatName'
    }, {
      title: this.$t('account.ddz'),
      dataIndex: 'sellerName'
    }];
    return {
      selectCustomerList: [],
      selectNumber: 0,
      listTotal: 0,
      queryParam: {
        page: 1,
        size: 5
      },
      isTableLoading: false,
      columns1: columns1,
      columns2: columns2,
      dyxList: [],
      removeTypeVisible: false,
      modalValue: {
        removeType: 0
      },
      crrentPageProductList: [],
      selectedRowKeys: [],
      updateLoading: false,
      total: 0,
      addList: [],
      alreadySelect: []
    };
  },
  mounted: function mounted() {
    console.log(this.activityId, this.lookinfo, '1222222222');
    if (this.activityId || this.$route.query.id) {
      this.getList(this.$route.query.id);
    }
  },
  watch: {
    'selectCustomerList': function selectCustomerList() {
      // console.log(this.selectCustomerList)
      this.selectNumber = this.selectCustomerList.length;
    }
  },
  methods: {
    getList: function getList(id) {
      var _this = this;
      this.isTableLoading = true;
      getActivityDyx(this.activityId || id).then(function (response) {
        var productData = response.data.data;
        if (productData !== null) {
          console.log(productData, 'data.........');
          _this.dyxList = productData;
          var idList = _.cloneDeep(productData);
          _this.alreadySelect = idList.map(function (item) {
            return item.erpCustomerId;
          });
          var newlist = _.cloneDeep(_this.dyxList);
          //初始肯定是第一页，那么需要截取第一页的数据
          _this.crrentPageProductList = newlist.splice(0, _this.queryParam.size);
          _this.listTotal = _this.dyxList.length;
        }
      }).finally(function () {
        _this.isTableLoading = false;
      });
    },
    addDyx: function addDyx() {
      var _this2 = this;
      this.$nextTick(function () {
        _this2.$refs.selectModal.visible = true;
      });
    },
    prevStep: function prevStep() {
      this.$emit('prevStep');
    },
    onChange: function onChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
    },
    onSelect: function onSelect(record, selected, selectedRows) {
      //如果选中，添加进去
      if (selected) {
        this.selectCustomerList = _.concat(this.selectCustomerList, record);
        console.log(this.selectCustomerList, '1111111111111');
      } else {
        console.log(record);
        console.log(this.selectCustomerList);
        //取消选中，失效
        this.selectCustomerList = _.remove(this.selectCustomerList, function (o) {
          return o.erpCustomerId != record.erpCustomerId;
        });
        console.log(this.selectCustomerList, '222222222222');
      }
    },
    onSelectAll: function onSelectAll(selected, selectedRows, changeRows) {
      var _this3 = this;
      if (selected) {
        this.selectCustomerList = _.concat(this.selectCustomerList, changeRows);
      } else {
        changeRows.forEach(function (item) {
          //取消选中，失效
          _this3.selectCustomerList = _.remove(_this3.selectCustomerList, function (o) {
            return o.erpCustomerId != item.erpCustomerId;
          });
        });
      }
    },
    tableChange: function tableChange(pagination, filters, sorter, _ref) {
      var currentDataSource = _ref.currentDataSource;
      this.queryParam.page = pagination.current;
      this.queryParam.size = pagination.pageSize;
      var newlist = _.cloneDeep(this.dyxList);
      //初始肯定是第一页，那么需要截取第一页的数据
      this.crrentPageProductList = newlist.splice((this.queryParam.page - 1) * this.queryParam.size, this.queryParam.size);
    },
    removeClick: function removeClick() {
      // this.dialogStatus = 'batchinvalid'
      this.modalValue.removeType = 0;
      this.removeTypeVisible = true;
    },
    deleteDyx: function deleteDyx(record) {
      //将这条记录从商品list 中移除
      this.dyxList = _.remove(this.dyxList, function (o) {
        return o.erpCustomerId != record.erpCustomerId;
      });
      this.alreadySelect = this.dyxList.map(function (item) {
        return item.erpCustomerId;
      });
      //移除过以后需要重新 获取一下当前页，要不然无法批量设置值
      var newlist = _.cloneDeep(this.dyxList);
      this.crrentPageProductList = newlist.splice((this.queryParam.page - 1) * this.queryParam.size, this.queryParam.size);
      this.listTotal = this.dyxList.length;
      // this.$message.success(this.$t('public.deleteSuccessfully'));
    },
    // 保存
    saveActivity: function saveActivity() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var saveData, res, _saveData, params, _res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!_this4.activityId) {
                _context.n = 5;
                break;
              }
              saveData = _.cloneDeep(_this4.dyxList);
              saveData = saveData.map(function (item) {
                return item.erpCustomerId;
              });
              _this4.updateLoading = true;
              _context.p = 1;
              console.log(_this4.oldList, 'old22222222222222222');
              _context.n = 2;
              return updateActivityDyx(_this4.activityId, saveData.join(','));
            case 2:
              res = _context.v;
              if (res.data.code == 200) {
                _this4.$message.success(_this4.$t('public.saveSuccessfully'));
              }
            case 3:
              _context.p = 3;
              _this4.updateLoading = false;
              return _context.f(3);
            case 4:
              _context.n = 9;
              break;
            case 5:
              _this4.updateLoading = true;
              _saveData = _.cloneDeep(_this4.dyxList);
              _saveData = _saveData.map(function (item) {
                return item.erpCustomerId;
              });
              console.log(_this4.basicInformation, 'basic...', _this4.basicProductContent);
              params = _objectSpread(_objectSpread(_objectSpread({}, _this4.basicInformation), _this4.basicProductContent), {}, {
                erpCustomerIds: _saveData.join(',')
              });
              _context.p = 6;
              _context.n = 7;
              return addActivity(params);
            case 7:
              _res = _context.v;
              if (_res.data.code == 200) {
                _this4.$message.success(_this4.$t('public.saveSuccessfully'));
                _this4.$emit('nextStep');
              }
            case 8:
              _context.p = 8;
              _this4.updateLoading = false;
              return _context.f(8);
            case 9:
              return _context.a(2);
          }
        }, _callee, null, [[6,, 8, 9], [1,, 3, 4]]);
      }))();
    },
    // 批量删除取消
    resetFormDate: function resetFormDate() {
      this.removeTypeVisible = false;
    },
    // 批量删除确认
    removeModal: function removeModal() {
      var _this5 = this;
      //判断是 选择的值，还是 当前页，还是全部页
      var lodingData = [];
      console.log(this.modalValue.removeType);
      if (this.modalValue.removeType == 0) {
        lodingData = _.cloneDeep(this.selectCustomerList);
      } else if (this.modalValue.removeType == 1) {
        lodingData = _.cloneDeep(this.crrentPageProductList);
      } else {
        lodingData = _.cloneDeep(this.dyxList);
      }
      {
        //移除
        console.log(lodingData, 'loading');
        lodingData.forEach(function (item) {
          _this5.dyxList = _.remove(_this5.dyxList, function (o) {
            return o.erpCustomerId != item.erpCustomerId;
          });
          _this5.selectCustomerList = _.remove(_this5.selectCustomerList, function (o) {
            return o.erpCustomerId != item.erpCustomerId;
          });
        });
        console.log(this.selectCustomerList, '2222');
        //移除过以后需要重新 获取一下当前页，要不然无法连续移除
        var newlist = _.cloneDeep(this.dyxList);
        this.crrentPageProductList = newlist.splice((this.queryParam.page - 1) * this.queryParam.size, this.queryParam.size);
      }
      this.alreadySelect = this.dyxList.map(function (item) {
        return item.erpCustomerId;
      });
      //如果商品list为 0 那么需要把分页的页码重置
      if (this.dyxList.length == 0) {
        this.queryParam.page = 1;
      }
      this.listTotal = this.dyxList.length;
      this.selectedRowKeys = [];
      this.selectNumber = 0;
      this.removeTypeVisible = false;
    },
    cancelDelete: function cancelDelete() {},
    confirmProduct: function confirmProduct(data) {
      console.log(data, 'data......');
      this.dyxList = data;
      this.alreadySelect = data.map(function (item) {
        return item.erpCustomerId;
      });
      this.listTotal = data.length;
      this.crrentPageProductList = this.dyxList.slice(0, this.queryParam.size);
    }
  }
};